module.exports = {
    appUrl: process.env.appUrl,
    apiUrl: process.env.apiUrl,
    mediaUrl: process.env.mediaUrl,
    crispWebsiteId: process.env.crispWebsiteId,
    tinymce: process.env.tinymce
};
